import * as IconPack from 'react-icons/md'

export default () => {
    const { ...exportIcons } = IconPack
    return exportIcons
}